// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3xA64","name":"Header_name__1Dyxa","birthday":"Header_birthday__PnE8K","skeleton":"Header_skeleton__3RSvp"};